import {
    enableProdMode,
    LOCALE_ID,
    TRANSLATIONS,
    TRANSLATIONS_FORMAT,
} from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { MainConfig } from './conf/main.config';

if (MainConfig.FRONTEND.PROD_MOD) {
    enableProdMode();
}

const savedLanguage = localStorage.getItem('language');
const locale = savedLanguage === 'fr' ? 'fr' : 'pt-BR';
localStorage.setItem('language', locale);
document.documentElement.lang = locale;

function bootstrapApp(translations: string = ''): void {
    platformBrowserDynamic([
        { provide: LOCALE_ID, useValue: locale },
        { provide: TRANSLATIONS_FORMAT, useValue: 'xlf' },
        { provide: TRANSLATIONS, useValue: translations },
    ])
        .bootstrapModule(AppModule)
        .catch((err) => console.error(err));
}

document.addEventListener('DOMContentLoaded', () => {
    if (locale === 'fr') {
        bootstrapApp();
        return;
    }

    fetch('/assets/i18n/messages.pt-BR.xlf')
        .then((response) => {
            if (!response.ok) {
                throw new Error('Não foi possível carregar a tradução pt-BR.');
            }
            return response.text();
        })
        .then((translations) => bootstrapApp(translations))
        .catch((error) => {
            console.error(error);
            bootstrapApp();
        });
});
